'use strict';

exports.__esModule = true;
exports.CODE_PARSING_PHASE_NAME = undefined;

var _performance = require('../performance/performance');

var _performance2 = _interopRequireDefault(_performance);

var _times = require('../times/times');

var _times2 = _interopRequireDefault(_times);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CODE_PARSING_PHASE_NAME = exports.CODE_PARSING_PHASE_NAME = 'codeParsingPhase';

var LoadingPhases = function () {
  function LoadingPhases(appName, times) {
    _classCallCheck(this, LoadingPhases);

    this.appName = appName;
    this.phases = new Map();
    this.indexToKey = new Map();
    this.times = times || new _times2.default(appName);
  }

  LoadingPhases._getIndexForPhase = function _getIndexForPhase(_ref) {
    var name = _ref.name,
        _ref$appId = _ref.appId,
        appId = _ref$appId === undefined ? '' : _ref$appId,
        _ref$widgetId = _ref.widgetId,
        widgetId = _ref$widgetId === undefined ? '' : _ref$widgetId;

    return name + '_' + appId + '_' + widgetId;
  };

  LoadingPhases.prototype.getAppLoadingPhaseData = function getAppLoadingPhaseData(_ref2) {
    var name = _ref2.name,
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;

    return this.phases.get(LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId }));
  };

  LoadingPhases.prototype.saveLoadingPhase = function saveLoadingPhase(_ref3) {
    var name = _ref3.name,
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId });

    if (!this.phases.has(phaseKey)) {
      var index = this.phases.size;
      this.phases.set(phaseKey, {
        name: name,
        phaseStartTime: _performance2.default.now(),
        index: index
      });

      this.indexToKey.set(index, phaseKey);
    }
  };

  LoadingPhases.prototype.endLoadingPhase = function endLoadingPhase(_ref4) {
    var name = _ref4.name,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId,
        widgetArray = _ref4.widgetArray;

    var phaseKey = LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId });
    if (!this.phases.has(phaseKey) || this.phases.get(phaseKey).duration) {
      return;
    }

    var phase = this.phases.get(phaseKey);
    phase.duration = _performance2.default.now() - phase.phaseStartTime;

    if (widgetArray) {
      phase.widgetArray = widgetArray;
    }
    if (widgetId) {
      phase.widgetId = widgetId;
    }

    this.phases.set(phaseKey, phase);
  };

  LoadingPhases.prototype.getNextPhaseToReport = function getNextPhaseToReport() {
    var latestStepIndex = this.phases.size - 1;
    var lastPhaseKey = this.indexToKey.get(latestStepIndex);
    return this.phases.get(lastPhaseKey);
  };

  LoadingPhases.prototype.getPhasePreviousTo = function getPhasePreviousTo(_ref5) {
    var name = _ref5.name,
        appId = _ref5.appId,
        widgetId = _ref5.widgetId;

    var currentPhase = this.phases.get(LoadingPhases._getIndexForPhase({ name: name, appId: appId, widgetId: widgetId }));
    var previousPhaseIndex = this.indexToKey.get(currentPhase.index - 1);
    return this.phases.get(previousPhaseIndex);
  };

  LoadingPhases.prototype.getPhases = function getPhases() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref6.appId;

    var phaseToNamedPhaseObject = function phaseToNamedPhaseObject(phase) {
      var _ref7;

      return _ref7 = {}, _ref7[phase.name] = phase, _ref7;
    };

    return Array.from(this.phases).filter(function (_ref8) {
      var phaseKey = _ref8[0];

      var _phaseKey$split = phaseKey.split('_'),
          appIdOfPhase = _phaseKey$split[1];

      return appId && appIdOfPhase === appId || !appId;
    }).map(function (_ref9) {
      var phase = _ref9[1];
      return phaseToNamedPhaseObject(phase);
    });
  };

  LoadingPhases.prototype.createCodeParsingPhaseIfNotExist = function createCodeParsingPhaseIfNotExist() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref10.appId,
        widgetId = _ref10.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: CODE_PARSING_PHASE_NAME,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey)) {
      var appLoadStartTime = this.times.getLoadStartTime({ appId: appId, widgetId: widgetId });

      this.phases.set(phaseKey, {
        phaseStartTime: appLoadStartTime,
        index: 0,
        name: CODE_PARSING_PHASE_NAME
      });

      this.indexToKey.set(0, phaseKey);
    }
  };

  return LoadingPhases;
}();

exports.default = LoadingPhases;